import { iaRa } from 'lib/helpers/utility';

import { showAlert } from 'components/shared/Alert/Alert';

import { ADVANCED_HISTORY_EXAMINATION_ID } from './constants';

export const handleDeleteCustomType = async ({
  data = {},
  currentFormId = null,
  customFormTypes = [],
  queryClient = {},
  selectedForm = null,
  closeIsConfirmModal = () => null,
  handleOnChange = () => null
}) => {
  const { code = null, error = null } = data ?? {};

  if (code !== 0) {
    showAlert({
      title: "Couldn't delete form type",
      message: error ?? 'Form could not be deleted. Please contact support.',
      color: 'danger'
    });

    closeIsConfirmModal({ resetFocus: true });
    return;
  }

  await Promise.all([
    queryClient.invalidateQueries(['customFormTypes']),
    queryClient.invalidateQueries(['customForm']),
    queryClient.invalidateQueries(['forms'])
  ]);

  const isDeletingCurrentSelectedFormType = currentFormId === selectedForm?.value;
  if (isDeletingCurrentSelectedFormType) {
    handleOnChange(
      iaRa(customFormTypes).find((option) => option?.value == ADVANCED_HISTORY_EXAMINATION_ID)
    );
  }

  showAlert({ title: 'Form type deleted', color: 'success' });
  closeIsConfirmModal({
    resetFocus: true
  });
};
